import { render } from "./property-baserecord-rental.vue?vue&type=template&id=5b67d3df"
import script from "./property-baserecord-rental.js?vue&type=script&lang=js"
export * from "./property-baserecord-rental.js?vue&type=script&lang=js"

import "./property-baserecord-rental.vue?vue&type=style&index=0&id=5b67d3df&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__